var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g3, _path19, _path20, _path21, _path22, _g4, _path23, _path24, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoLoan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 326,
    height: 215,
    viewBox: "0 0 326 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M324.643 211.514C332.506 195.954 310.035 118.154 154.223 118.154C41.7578 118.154 -9.86056 181.835 1.55123 214.108",
    fill: "url(#paint0_radial_218_2578)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_218_2578",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 118,
    width: 326,
    height: 97
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M324.643 211.514C332.506 195.954 310.035 118.154 154.223 118.154C41.7578 118.154 -9.86056 181.835 1.55123 214.108",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_218_2578)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.671968,
    cx: 130.192,
    cy: 186.859,
    rx: 8.56892,
    ry: 4.75961,
    fill: "url(#paint1_linear_218_2578)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.256348,
    cx: 217.651,
    cy: 154.518,
    rx: 13.5199,
    ry: 7.425,
    fill: "url(#paint2_linear_218_2578)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.729957,
    cx: 63.7909,
    cy: 134.717,
    rx: 13.5199,
    ry: 7.425,
    fill: "url(#paint3_linear_218_2578)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M127.015 135.408C127.015 135.408 160.17 150.998 173.323 156.981C183.742 161.72 237.389 176.881 243.78 172.572C250.171 168.262 264.282 156.435 259.623 148.331C254.965 140.228 230.465 125.678 218.748 123.553C207.031 121.427 173.528 131.091 173.528 131.091L144.951 135.998L127.015 135.408Z",
    fill: "url(#paint4_linear_218_2578)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.59 65.7013L114.643 92.8679L124.495 69.7554L161.495 46.2652L151.59 65.7013Z",
    fill: "#E2E7EC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.88 70.2324L161.495 46.6846V110.906L127.014 135.081L123.88 70.2324Z",
    fill: "#D8DFE6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M161.495 46.6846L219.172 60.1782V124.423L161.495 110.929V46.6846Z",
    fill: "#E9EFF1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.88 70.2292L182.811 84.0013V148.246L127.014 135.434L123.88 70.2292Z",
    fill: "#E8EAEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M181.557 84.0248L219.172 60.4769V124.698L181.557 148.246V84.0248Z",
    fill: "#D8DFE6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_218_2578",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 181,
    y: 60,
    width: 39,
    height: 89
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M181.557 84.0248L219.172 60.4769V124.698L181.557 148.246V84.0248Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_218_2578)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195.529,
    y: 55.1252,
    width: 11.822,
    height: 98.4728,
    fill: "#C7D0D9"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M198.472 103.108L235.472 79.6175L218.558 60.4769L181.557 83.9671L198.472 103.108Z",
    fill: "#E2E7EC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M95.0254 137.027L153.22 166.762L158.653 151.005L101.555 132.012L95.0254 137.027Z",
    fill: "url(#paint5_linear_218_2578)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4367 88.1456L113.503 89.7274L109.047 133.376C109.047 133.376 108.657 133.813 107.71 133.643C106.764 133.474 105.77 132.947 105.77 132.947L102.786 98.2473C102.786 98.2473 101.06 110.517 101.18 113.969C101.271 116.57 102.16 119.743 102.636 122.457C103.046 124.792 103.908 130.374 103.908 130.374C103.908 130.374 102.889 130.839 102.348 130.944C101.806 131.049 101.112 130.472 101.112 130.472C101.112 130.472 94.0764 116.814 93.9858 114.22C93.8952 111.627 93.4367 88.1456 93.4367 88.1456Z",
    fill: "url(#paint6_linear_218_2578)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100.799 130.408C100.799 130.408 99.9056 132.017 98.7953 132.998C97.685 133.979 95.494 135.151 94.9946 135.683C94.4951 136.216 95.0405 137 95.0405 137L100.41 136.813L104.701 133.183L104.101 129.724L100.799 130.408Z",
    fill: "#677285"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M109.552 132.271L110.806 135.748C110.806 135.748 108.747 137.343 105.903 137.786C103.059 138.23 101.099 137.548 101.099 137.548C101.099 137.548 100.585 136.514 101.553 136.071C101.998 135.868 102.994 135.024 103.869 133.943C104.264 133.455 105.751 132.404 105.751 132.404L109.552 132.271Z",
    fill: "#677285"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M118.541 65.389C118.541 65.389 120.186 67.891 121.194 67.2215C122.203 66.552 128.498 60.099 128.498 60.099C128.498 60.099 130.371 58.6572 130.718 58.9999C131.064 59.3427 130.093 60.099 130.093 60.099C130.093 60.099 132.137 60.2997 132.775 60.2997C133.414 60.2997 134.757 61.3192 133.879 61.6623C133 62.0054 129.593 62.0901 129.593 62.0901C129.593 62.0901 124.421 71.8715 121.726 72.5651C119.031 73.2586 115.317 69.3361 115.317 69.3361L118.541 65.389Z",
    fill: "#FDE7E6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2627 65.5684C92.2627 65.5684 91.1843 67.7765 90.207 67.2467C89.2298 66.717 83.7467 60.9346 83.7467 60.9346C83.7467 60.9346 81.9207 59.8163 81.4742 60.0175C81.0277 60.2187 82.1285 60.9346 82.1285 60.9346C82.1285 60.9346 79.442 61.1526 78.9367 61.3557C78.4313 61.5588 77.8427 62.1818 78.6068 62.4649C79.3709 62.7481 82.2958 62.9495 82.2958 62.9495C82.2958 62.9495 86.362 70.9845 89.4427 71.924C92.5233 72.8635 95.1479 69.1616 95.1479 69.1616L92.2627 65.5684Z",
    fill: "#FDE7E6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M102.238 58.806V54.8583C102.238 54.8583 100.191 54.962 99.3587 53.5914C98.5267 52.2208 98.302 48.3314 98.302 48.3314L98.9289 46.5281L105.094 46.2676L108.333 49.0276L106.825 51.6911L106.537 52.2029L107.975 58.2562L102.238 58.806Z",
    fill: "#FDE7E6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_218_2578",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 98,
    y: 46,
    width: 11,
    height: 13
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M102.238 58.806V54.8583C102.238 54.8583 100.191 54.962 99.3587 53.5914C98.5267 52.2208 98.302 48.3314 98.302 48.3314L98.9289 46.5281L105.094 46.2676L108.333 49.0276L106.825 51.6911L106.537 52.2029L107.975 58.2562L102.238 58.806Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_218_2578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.247 51.1073C104.425 53.3732 101.274 54.9569 100.864 54.9569C100.453 54.9569 103.155 57.7988 103.155 57.7988L105.353 58.8065L108.473 58.1451L109.586 54.9569L107.62 51.3396C107.62 51.3396 108.069 48.8413 106.247 51.1073Z",
    fill: "url(#paint7_linear_218_2578)"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9521 67.1542L93.9817 71.2351L95.9139 69.1946C95.9139 69.1946 94.4444 77.2519 93.9817 81.1162C93.5191 84.9805 93.433 88.8294 93.433 88.8294C93.433 88.8294 98.2841 90.6305 101.9 90.9335C105.517 91.2365 113.935 90.4563 113.935 90.4563L112.849 67.7757L116.002 70.703L119.704 66.4281C119.704 66.4281 113.331 56.634 112.126 56.0635C110.92 55.4929 107.57 56.0635 107.57 56.0635C107.57 56.0635 105.193 58.8769 104.229 58.9162C103.265 58.9554 101.126 56.0635 101.126 56.0635C101.126 56.0635 97.7096 55.5178 96.7162 56.634C95.7228 57.7503 90.9521 67.1542 90.9521 67.1542Z",
    fill: "url(#paint8_linear_218_2578)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3017 48.3753C98.3017 48.3753 99.0283 46.5419 99.9767 46.8614C100.874 47.1637 101.652 47.883 102.768 48.2207C103.885 48.5583 104.008 47.0414 104.767 47.2976C105.526 47.5537 105.025 49.7852 105.56 50.2007C106.095 50.6163 106.095 47.2976 107.235 48.191C108.375 49.0845 106.045 51.5992 106.045 51.5992C106.045 51.5992 106.344 53.1449 106.44 53.25C106.535 53.3551 106.524 52.1255 106.524 52.1255C106.524 52.1255 107.613 51.7075 108.077 49.8223C108.541 47.9371 108.742 47.1866 108.077 45.8168C107.413 44.447 107.223 43.3743 105.56 42.7281C103.896 42.0819 102.634 42.3347 101.472 42.7281C100.309 43.1215 99.4664 43.9033 98.9287 44.6812C97.6748 46.5277 98.3017 48.3753 98.3017 48.3753Z",
    fill: "#4D364F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.396 0.0232123C209.075 0.427082 181.722 16.7926 181.722 16.7926L189.704 17.3878L195.377 23.6566C195.377 23.6566 211.717 -0.380657 210.396 0.0232123Z",
    fill: "#E8EAEB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_218_2578",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 181,
    y: 0,
    width: 30,
    height: 24
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.396 0.0232123C209.075 0.427082 181.722 16.7926 181.722 16.7926L189.704 17.3878L195.377 23.6566C195.377 23.6566 211.717 -0.380657 210.396 0.0232123Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_218_2578)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.704 17.3878L210.396 0.0231987L195.376 23.6565L189.704 17.3878Z",
    fill: "#D8DFE6"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.288 18.987L196.697 17.9845L210.406 0.19217L206.288 18.987Z",
    fill: "#E8EAEB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.629 30.8409C189.228 29.5727 189.831 28.2599 190.439 26.9027L191.43 27.3467C190.82 28.7106 190.213 30.0301 189.611 31.3051L188.629 30.8409ZM184.726 38.578C185.388 37.3561 186.056 36.0763 186.729 34.7386L187.699 35.227C187.021 36.5744 186.349 37.864 185.681 39.0958L184.726 38.578ZM182.595 42.3421C181.823 43.6437 181.058 44.8636 180.302 46.0016L181.206 46.6033C181.974 45.4493 182.748 44.2138 183.529 42.8965L182.595 42.3421ZM175 52.7715C175.916 51.8209 176.847 50.736 177.79 49.5168L178.649 50.182C177.683 51.4311 176.727 52.5457 175.782 53.5257L175 52.7715ZM171.809 55.5794C170.539 56.4897 169.302 57.1193 168.099 57.4712L168.404 58.5142C169.731 58.1259 171.077 57.441 172.442 56.4627L171.809 55.5794ZM160.435 55.6941C161.63 56.6577 162.845 57.2888 164.081 57.5932L163.821 58.6484C162.423 58.3041 161.066 57.5994 159.752 56.54L160.435 55.6941ZM157.505 52.6076C157.437 52.5194 157.37 52.4302 157.303 52.3398C156.428 51.1623 155.793 50.0449 155.388 48.9894L154.373 49.3789C154.816 50.532 155.5 51.7347 156.431 52.9878C156.501 53.0821 156.571 53.1752 156.641 53.2672L157.505 52.6076ZM157.245 41.6763C156.072 42.6459 155.317 43.7587 155.009 45.0002L153.954 44.7386C154.321 43.2573 155.209 41.949 156.553 40.8385L157.245 41.6763ZM160.876 39.6345C162.098 39.157 163.473 38.7676 164.964 38.4736L164.754 37.4075C163.202 37.7134 161.766 38.1202 160.48 38.6222L160.876 39.6345ZM173.472 37.852C172.026 37.8006 170.585 37.8245 169.182 37.9233L169.106 36.8393C170.547 36.7378 172.027 36.7133 173.51 36.7661L173.472 37.852ZM177.798 38.2329C179.255 38.4403 180.664 38.7243 181.995 39.0804L182.276 38.0307C180.902 37.6631 179.45 37.3704 177.951 37.1571L177.798 38.2329ZM189.637 42.6615C188.643 41.8529 187.431 41.127 186.031 40.4962L186.477 39.5055C187.959 40.1732 189.251 40.9471 190.322 41.8187L189.637 42.6615ZM192.227 45.9255C192.489 46.5346 192.657 47.1692 192.728 47.8291C192.803 48.5273 192.829 49.2291 192.806 49.9346L193.892 49.97C193.916 49.2141 193.889 48.4618 193.808 47.7134C193.726 46.9446 193.53 46.2043 193.225 45.4959L192.227 45.9255ZM190.486 58.0312C191.185 56.712 191.727 55.4067 192.111 54.1152L193.152 54.4248C192.747 55.7871 192.178 57.1589 191.446 58.5402L190.486 58.0312ZM188.186 61.6643C187.382 62.7592 186.473 63.8628 185.459 64.9751L186.262 65.7071C187.301 64.5672 188.234 63.4341 189.062 62.3075L188.186 61.6643ZM179.218 70.8546C180.371 69.8997 181.452 68.9505 182.458 68.0071L183.201 68.8C182.178 69.759 181.081 70.7228 179.911 71.6917L179.218 70.8546ZM175.794 73.5456C174.677 74.3813 173.505 75.2213 172.278 76.0654L172.894 76.9606C174.132 76.1085 175.316 75.2602 176.445 74.4156L175.794 73.5456ZM166.372 79.9008C167.144 79.4256 167.899 78.9517 168.638 78.4791L169.224 79.3942C168.48 79.8704 167.719 80.3477 166.942 80.8262L166.372 79.9008Z",
    fill: "#C7D0D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_218_2578",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(141.387 151.431) rotate(-90) scale(55.7898 582.669)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEDF0",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536775,
    stopColor: "#EBEDF0",
    stopOpacity: 0.845525
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E4E7",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_218_2578",
    x1: 123.294,
    y1: 185.597,
    x2: 125.905,
    y2: 191.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D6DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_218_2578",
    x1: 206.299,
    y1: 153.823,
    x2: 211.075,
    y2: 163.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D6DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_218_2578",
    x1: 55.1703,
    y1: 134.837,
    x2: 57.8733,
    y2: 145.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_218_2578",
    x1: 122.143,
    y1: 140.814,
    x2: 131.787,
    y2: 184.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CDD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6CFD3",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_218_2578",
    x1: 93.006,
    y1: 145.168,
    x2: 104.194,
    y2: 174.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CDD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6CFD3",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_218_2578",
    x1: 114.954,
    y1: 133.456,
    x2: 113.36,
    y2: 87.7951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A7B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B8195"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_218_2578",
    x1: 107.111,
    y1: 56.1557,
    x2: 107.111,
    y2: 52.3307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC0BE",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_218_2578",
    x1: 76.4071,
    y1: 71.8685,
    x2: 106.636,
    y2: 103.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2DAE8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLoan);
export default __webpack_public_path__ + "static/media/NoLoan.5f6b328dbd39b31ea2b817549f80cb10.svg";
export { ForwardRef as ReactComponent };